import Dashboard from "./components/SharedPortal/Dashboard";
import HouseholdEditor from "./components/SharedPortal/profile/HouseholdEditor";
import Layout from "./components/SharedPortal/Layout";
import MyProfile from "./components/SharedPortal/MyProfile";
import ParentEditor from "./components/SharedPortal/profile/ParentEditor";
import TestPage from "./components/SharedPortal/TestPage";
import PropTypes from 'prop-types';
import React from 'react';
import SchoolExplorer from "./components/SharedPortal/SchoolExplorer";
import StudentIntake from "./components/SharedPortal/StudentIntake";
import globalHistory from 'shared_history';
import { Router, Route, IndexRoute, Redirect } from 'react-router';
import { hot } from 'react-hot-loader';
import { syncHistoryWithStore } from 'react-router-redux';


/**
 * React routes for the shared portal. These are independent from the main Routes.jsx file and are allowed
 * to overlap. When adding a route, be sure to add a corresponding rails route to `config/routes/shared_portal.rb`.
 */
class SharedPortalRoutes extends React.Component {

  static contextTypes = {
    store: PropTypes.object
  };

  render() {
    const { store } = this.context;
    const history = syncHistoryWithStore(globalHistory, store);

    return (
      <Router history={history}>
        <Route path="/" component={Layout}>
          <IndexRoute component={Dashboard} />
          <Route path="households(/:id)" component={HouseholdEditor} />
          <Redirect from='intakes' to={redirectIntakes(window.location, this.props.branded_shared_portal_host)} exact />
          <Route path="intakes/:page(/:id)" component={StudentIntake} />
          <Route path="parents(/:id)" component={ParentEditor} />
          <Route path="explore_schools" component={SchoolExplorer} />
          <Route path="profile" component={MyProfile} />
          <Redirect from='students' to='students/student' exact />
          <Route path="students/:page(/:id)" component={StudentIntake} />
          <Route path="embed_test" component={TestPage} />
        </Route>
      </Router>
    );
  }
}

function redirectIntakes(location, brandedSharedPortalHost) {
  let { hostname, search } = location;
  let acc = hostname.split('.');
  acc.shift();
  hostname = acc.join('.');

  return hostname === brandedSharedPortalHost ? `intakes/student${search}` : `intakes/location${search}`;
}

export default hot(module)(SharedPortalRoutes);
